module.exports = __webpack_public_path__ + "static/developer-8599bfcd1508aed919e6744474aee005.svg";